export default "__VITE_ASSET__RUUuzCIR__"